"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.getFullAddressFromPartial = getFullAddressFromPartial, exports.buildAddressFromString = buildAddressFromString, exports.isValidAddress = isValidAddress;
var SPACE = " ";

function getAddressMatch(a, b, c) {
  if (!a.includes(SPACE)) return b;
  var d = a.match(c);
  return d ? d[0] : b;
}

function getAddressValue(a) {
  return a ? a.trim() : "";
}

function getFullAddressFromPartial(a) {
  return {
    country: getAddressValue(a.country),
    unit: getAddressValue(a.unit),
    street: getAddressValue(a.street),
    citySuburb: getAddressValue(a.citySuburb),
    state: getAddressValue(a.state),
    postCode: getAddressValue(a.postCode)
  };
}

function buildAddressFromString(a) {
  var b = a.split(",");
  if (!b[b.length - 2]) return {
    country: b[0]
  };
  var c = b[b.length - 2].trim(),
      d = getAddressMatch(c, "", /\b(\w+)\W*$/),
      e = getAddressMatch(c, c, /.*?(?=\w+$)/);
  return getFullAddressFromPartial({
    citySuburb: e,
    state: d,
    country: b[b.length - 1],
    street: b[0]
  });
}

function isValidAddress(a) {
  return !!(a.street && a.country && a.citySuburb && a.state && a.postCode);
}